import React, {CSSProperties} from "react";
import {Column, RowData} from "@tanstack/react-table";

import {Checkbox} from "@pg-design/checkbox-module";
import {Text} from "@pg-design/text-module";

import * as styles from "./TableColumnVisibility.module.css";

interface IProps<TData> {
    areAllColumnsVisible: boolean;
    areSomeColumnsVisible: boolean;
    onToggleAll: (event: unknown) => void;
    columns: Column<TData, unknown>[];
    style?: CSSProperties;
}

export const TableColumnVisibility = <TData extends RowData>(props: IProps<TData>) => {
    return (
        <div className={styles.columnVisibility} style={props.style}>
            <Text variant="headline_6" mb={2}>
                <Checkbox
                    onChange={props.onToggleAll}
                    checked={props.areAllColumnsVisible}
                    labelContent="Widoczność kolumn"
                    id="toggle"
                    name="toggle"
                    checkedMarkColor="#02D054"
                />
            </Text>
            {props.columns.map((column) =>
                typeof column.columnDef.header !== "function" ? (
                    <div key={column.id} className={styles.column}>
                        <Checkbox
                            onChange={(_name, checked) => {
                                column.getToggleVisibilityHandler()({target: {checked}});
                            }}
                            checked={column.getIsVisible()}
                            labelContent={column.columnDef.header || column.id}
                            id={column.id}
                            name={column.id}
                            checkedMarkColor="#02D054"
                        />
                    </div>
                ) : null
            )}
        </div>
    );
};
import React, {CSSProperties} from "react";
import {Column, RowData} from "@tanstack/react-table";

import {Checkbox} from "@pg-design/checkbox-module";
import {Text} from "@pg-design/text-module";

import * as styles from "./TableColumnVisibility.module.css";

interface IProps<TData> {
    areAllColumnsVisible: boolean;
    areSomeColumnsVisible: boolean;
    onToggleAll: (event: unknown) => void;
    columns: Column<TData, unknown>[];
    style?: CSSProperties;
}

export const TableColumnVisibility = <TData extends RowData>(props: IProps<TData>) => {
    return (
        <div className={styles.columnVisibility} style={props.style}>
            <Text variant="headline_6" mb={2}>
                <Checkbox
                    onChange={props.onToggleAll}
                    checked={props.areAllColumnsVisible}
                    labelContent="Widoczność kolumn"
                    id="toggle"
                    name="toggle"
                    checkedMarkColor="#02D054"
                />
            </Text>
            {props.columns.map((column) =>
                typeof column.columnDef.header !== "function" ? (
                    <div key={column.id} className={styles.column}>
                        <Checkbox
                            onChange={(_name, checked) => {
                                column.getToggleVisibilityHandler()({target: {checked}});
                            }}
                            checked={column.getIsVisible()}
                            labelContent={column.columnDef.header || column.id}
                            id={column.id}
                            name={column.id}
                            checkedMarkColor="#02D054"
                        />
                    </div>
                ) : null
            )}
        </div>
    );
};
